import { combineReducers } from 'redux';
import { REQUERT_NEW_PLANTEMPLATE_FAILED, GET_DATA_NEW_PLANTEMPLATE_SUCCEEDED, GET_DATA_EMAIL_SUCCEEDED, REQUERT_DATA_EMAIL_FAILED } from '../actions/actionTypes'

const newReducer = (DataNew = [], actions) => {
    switch (actions.type) {
        case GET_DATA_NEW_PLANTEMPLATE_SUCCEEDED:
            if(Object.keys(actions.DataNew).length > 0)
            {
                return {...DataNew, DataNew: actions.DataNew};
            }
            else
            {
                return {...DataNew,DataNew: []};
            }
        case REQUERT_NEW_PLANTEMPLATE_FAILED:
            return {...DataNew,DataNew: []};
        default:
            return DataNew;
    }
}

const emailReducer = (DataEmail = [], actions) =>{
    switch (actions.type) {
        case GET_DATA_EMAIL_SUCCEEDED:
            if(Object.keys(actions.DataEmail).length > 0)
            {
                return {...DataEmail, DataEmail: actions.DataEmail};
            }
            else
            {
                return {...DataEmail,DataEmail: []};
            }
        case REQUERT_DATA_EMAIL_FAILED:
            return {...DataEmail,DataEmail: []};
        default:
            return DataEmail;
    }
}
const newAllReducers = combineReducers({
    newReducer, emailReducer
})
export default newAllReducers;